import React from 'react';
import {Field} from 'redux-form';

import {positiveInteger} from 'utils/validators';

import Label from 'components/Label';
import FormField from 'components/FormField';
import {NumberField, CheckBoxField} from 'components/Fields';

import './styles.css';

export const initialValues = () => ({
  createCleanup: true,
  cleanupPeriodDays: 2
});

const CleanupPeriodSection = ({
  createCleanupValue,
  onCleanupPeriodCheckboxChange,
  onCleanupPeriodDaysChange
}) => (
  <div className="CleanupPeriodSection">
    <div className="formContainer">
      <FormField className="createCleanupPeriodField">
        <Field
          name="createCleanup"
          component={CheckBoxField}
          label={'Include a cleanup period'}
          onChange={onCleanupPeriodCheckboxChange}
        />
      </FormField>
      {createCleanupValue && (
        <FormField>
          <Label>Cleanup period duration</Label>
          <div className="cleanupPeriodDays">
            <Field
              name="cleanupPeriodDays"
              className="cleanupPeriodDays"
              component={NumberField}
              onChange={onCleanupPeriodDaysChange}
              validate={[positiveInteger]}
            />
            <div className="label">Days</div>
          </div>
        </FormField>
      )}
    </div>
  </div>
);

export default CleanupPeriodSection;
